import { useParams } from 'react-router-dom';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import { RateShipperPage } from './RateShipperPage';

export function RateShipperScreen() {
  const { guid = '' } = useParams();
  useDocumentTitle('Rate Shipper');

  return (
    <WebviewLayout>
      <RateShipperPage guid={guid} />
    </WebviewLayout>
  );
}
